// components/BranchesList.jsx
import { FaCodeBranch } from "react-icons/fa6";
import { BranchCard } from "../misc/BranchCard";
import { ICompanyBranch } from "../../../store/@types/company";

type IBranchesList = {
  branches: ICompanyBranch[] | null;
  selectedBranchId: string | null;
  onBranchSelect: (branchId: string) => void;
};

export const BranchesList = ({
  branches,
  selectedBranchId,
  onBranchSelect,
}: IBranchesList) => {
  return (
    <div className="mt-6 space-y-4">
      <h4 className="flex items-center gap-2 text-xl font-semibold text-primary-700">
        <span className="p-2 bg-primary-50/20 rounded-xl">
          <FaCodeBranch size={14} />
        </span>
        <span>Company Branch(s)</span>
      </h4>
      <div className="grid gap-6 grid-cols-[repeat(auto-fill,minmax(min(300px,100%),1fr))]">
        {branches?.map((branch) => (
          <BranchCard
            key={branch.id}
            branch={branch}
            isSelected={selectedBranchId === branch.id}
            onSelect={() => onBranchSelect(branch.id)}
          />
        ))}
      </div>
    </div>
  );
};
